



















import '../assets/scss/init.scss'
import { Component, Vue, namespace, Prop } from 'nuxt-property-decorator'
import { App } from '@capacitor/app'
import { ISiteScriptItem } from '~/assets/interfaces/site'
import { ICssVariables, IStyle } from '~/assets/interfaces/classes'
import { IMeta } from '~/assets/interfaces/meta'
import ComponentTypographyH1 from '~/components/typography/h1.vue'
const siteStore = namespace('site')
const pageStore = namespace('page')
const authStore = namespace('auth')

@Component({
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    ComponentTypographyH1,
  },
})
export default class layoutError extends Vue {
  @Prop({ type: Object, default: () => {} }) error!: Record<
    string,
    string | number
  >

  @siteStore.State('scripts') private scripts!: ISiteScriptItem[]
  @siteStore.State('token') private token!: string | null
  @pageStore.Mutation('setMeta') private setMeta!: (meta: IMeta) => void
  @pageStore.State('meta') private meta!: IMeta
  @siteStore.State('cssVariables') private cssVariables!: ICssVariables | null
  @authStore.State('loggedIn') private loggedIn!: boolean

  private created(): void {
    this.title =
      this.error.statusCode === 404 ? this.pageNotFound : this.otherError
    if (this.token) {
      this.$axios.setToken(this.token)
    }
    this.setMeta({
      h1: this.title,
      title: this.title,
    })
  }

  private get cssVariablesStyle() {
    let style = ':root {'
    for (const color in this.cssVariables) {
      style = style + '--color-' + color + ': ' + this.cssVariables[color] + ';'
    }
    style = style + '}'
    return style
  }

  private pageNotFound = '404 - Такой страницы не существует'
  private otherError = 'Упс... Ошибочка'

  private title = ''
  private $style!: IStyle

  private head() {
    const base: any = {
      title: this.title,
      style: [
        {
          innerHTML: this.cssVariablesStyle,
        },
      ],
    }
    this.scripts.forEach((item) => {
      if (!base[item.type]) {
        base[item.type] = []
      }
      base[item.type].push({ ...item.attr })
    })
    return base
  }

  private mounted(): void {
    if (this.error.statusCode === 403 && !this.loggedIn) {
      this.$nuxt.$emit('open-auth-popup')
    }
    App.addListener('backButton', () => {
      this.$router.go(-1)
    })
  }
}
